/**
 * @packageDocumentation
 * @module api.functional.receivings
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

/**
 * @controller ReceivingController.findAll
 * @path GET /receivings
 * @accessor api.functional.receivings.findAll
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function findAll(connection: IConnection): Promise<void> {
  return PlainFetcher.fetch(connection, {
    ...findAll.METADATA,
    template: findAll.METADATA.path,
    path: findAll.path(),
  });
}
export namespace findAll {
  export const METADATA = {
    method: "GET",
    path: "/receivings",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = () => "/receivings";
}
